import { gql } from '@apollo/client';

export const LIMIT = 20;
export const DEBOUNCE_TIME = 700;
export const ORDER = 'created_at DESC';

export const CHANGE_MODERATED_SETTINGS = gql`
  mutation UpdateCompanyModeratedSettings($companyId: ID!, $callLink: String) {
    updateCompanyModeratedSettings(companyId: $companyId, callLink: $callLink) {
      company {
        id
        callLink
        moderatedSettings
      }
    }
  }
`;

export const CHANGE_PLAN = gql`
  mutation ChangePlan($companyId: ID!, $plan: CompanyPlanEnum!) {
    changePlan(companyId: $companyId, plan: $plan) {
      company {
        id
        plan
      }
    }
  }
`;

export const CHANGE_CUSTOMER_TYPE = gql`
  mutation ChangeCustomerType($companyId: ID!, $customerType: CustomerTypeEnum!) {
    changeCustomerType(companyId: $companyId, customerType: $customerType) {
      company {
        id
        customerType
      }
    }
  }
`;

export const CHANGE_BALANCE = gql`
  mutation UpdateCompanyBalance($companyId: ID!, $amountRemaining: Int!) {
    updateCompanyBalance(companyId: $companyId, amountRemaining: $amountRemaining) {
      company {
        id
        balanceAmountUsed
        balanceRemaining
        prepaidBalance
      }
    }
  }
`;

export const CHANGE_TOTAL_AMOUNT = gql`
  mutation UpdateCompanyTotalAmount($companyId: ID!, $totalAmount: Int!) {
    updateCompanyTotalAmount(companyId: $companyId, totalAmount: $totalAmount) {
      company {
        id
        totalAmount
        totalAmountFormatted
      }
    }
  }
`;

export const UPDATE_START_CONTRACT_DATE = gql`
  mutation UpdateCompanyContractStartDate($companyId: ID!, $contractStartDate: ISO8601DateTime) {
    updateCompanyContractStartDate(companyId: $companyId, contractStartDate: $contractStartDate) {
      company {
        id
        contractStartDate
      }
    }
  }
`;

export const UPDATE_RENEWAL_DATE = gql`
  mutation UpdateCompanyContractStartDate($companyId: ID!, $renewalDate: ISO8601DateTime) {
    updateCompanyRenewalDate(companyId: $companyId, renewalDate: $renewalDate) {
      company {
        id
        renewalDate
      }
    }
  }
`;

export const GET_ALL_COMPANIES = gql`
  query Companies($limit: Int!, $offset: Int!, $order: String!, $search: String) {
    companies(limit: $limit, offset: $offset, order: $order, search: $search) {
      id
      name
      plan
      balanceAmountUsed
      balanceRemaining
      prepaidBalance
      userEligibilityCount
      pastTestersCount
      callLink
      moderatedSettings
      companyMembersCount
      stripeCustomerId
      customerType
      contractStartDate
      renewalDate
      totalAmount
      totalAmountFormatted
      companyMembers {
        id
        user {
          id
          email
          resetPasswordToken
          profile {
            id
            firstName
            lastName
            linkedinFields {
              id
              emailAddress
            }
          }
        }
      }
    }
  }
`;

export const GENERATE_PASSWORD_LINK = gql`
  mutation GeneratePasswordLink($id: ID!){
    generatePasswordRecoverLink(id: $id){
      resetPasswordToken
    }
  }
`;
